export const Wrapper =
  'text-14 font-Roboto mb-10 flex mx-auto md:ml-0 max-w-[400px] md:w-full md:max-w-none flex-col md:flex-row shadow-md md:shadow-none'

export const LeftWrapper = 'flex w-full flex-col md:w-1/2 max-w-[420px]'

export const RightWrapper =
  'flex w-full flex-col p-4 md:px-0 md:pb-0 pt-4 md:pt-6 md:w-1/2 md:pl-[48px] justify-between'

export const ImageWrapper =
  'max-h-[300px] w-full md:max-h-[280px] overflow-hidden'

export const Image = 'h-full w-full object-cover'

export const MachineDetailsWrapper = 'flex w-full flex-col shrink-0'

export const MachineActionsWrapper = 'flex w-full flex-col pt-6 md:pt-2'

export const MachineDetailLineItem = 'pb-2 md:pb-6 last-of-type:pb-0'

export const MachineDetailLabel = 'text-grayRegular'

export const MachineDetailContent = ''
